/*globals jQuery */
( function() {
	'use strict';

	// Define global object.
	if ( typeof window.MSR !== 'object' ) {
		window.MSR = {};
	}

	// COLLECTIONS NO-FLEXBOX LAYOUT FIX
	window.MSR.collectionsFix = ( function( $ ) {
		var config;

		var init = function( settings ) {
			config = {
				fixedEl: '.msr-collection-inner--fixed',
				adjustEl: '.msr-collection-inner'
			};

			$.extend( config, settings );

			set();
		};

		var set = function() {
			$( config.adjustEl ).height( $( config.fixedEl ).height() );
		};

		return {
			init: init
		};
	} )( jQuery );
} )();
